import React, { useState, useEffect, useRef } from "react";
import { Button, message, Modal, Row } from 'antd';
import "./index.less";
import { useLocation, useNavigate } from "react-router-dom";
import wxIcon from "@/assets/wx.png";
import xykIcon from "@/assets/xyk.png";
import aliIcon from "@/assets/ali.png";
import { request } from "@/utils";
import { baseUrl } from "@/utils/request";
import selectIcon from '@/assets/select-icon.png'

export default function Pay(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [paySchema, setPaySchema] = useState('');
    const [payChooseWx, setPayChooseWx] = useState('wxpay')
    const [visible, setVisible] = useState(false);
    const payTimeRef = useRef(null)
    const [loading, setLoading] = useState(false);
    const targetPayChooseWx = async () => {
        setLoading(true)
        let type = searchParams.get('type')
        let requestUrl = type == '0' ? 'restaurant/pay' : 'goodseat_order/pay'
        try {
            const response = await request.post(requestUrl, {
                sn: searchParams.get('sn'),
                platform: 'web',
                pay_type: payChooseWx,
            });
            setLoading(false)
            console.log(response, 'sss')
            if (response.code == 0) {
                setPaySchema(response.data);
                if (payChooseWx == 'alipay' || payChooseWx == 'wxpay') {
                    setVisible(true);
                    payTimeRef.current = setInterval(() => {
                        getDetail(searchParams.get('id'))
                    }, 5000)
                } else {
                    window.location.href = response.data.paypal_url;
                }
            } else {
                message.error(response.msg);
            }
        } catch (error) {
            message.error('支付失败');
        }
    }
    useEffect(() => {
        console.log(searchParams.get('type'), 'ooooo')
        return () => {
            console.log('组件卸载时执行清理操作')
            clearInterval(payTimeRef.current); // 先清除定时器
            payTimeRef.current = null; // 再将引用置为 null
            setVisible(false);
        };
    }, []);
    const getDetail = async () => {
        let requestUrl = searchParams.get('type') == '0' ? 'restaurant/reservation_order_detail' : 'goodseat_order/detail'
        try {
            const response = await request.get(requestUrl + '?id=' + searchParams.get('id'));
            if ((response.data.pay_time > 0 && searchParams.get('type') == '0') || (response.data.order_status == 2 && searchParams.get('type') == '1')) {
                clearInterval(payTimeRef.current); // 先清除定时器
                payTimeRef.current = null; // 再将引用置为 null
                setVisible(false);
                if (searchParams.get('from') === 'order' || searchParams.get('from') === 'orderDetail') {
                    navigate(-1)
                    return
                }
                if (searchParams.get('type') == '0') {
                    navigate('/orderDetail?id=' + searchParams.get('id'),)
                } else {
                    navigate('/transferOrderDetail?id=' + searchParams.get('id'),)
                }

            }
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    }
    return (
        <>
            <div className="pay-background">
                <div className="pay-content">
                    <Button type="cancel" style={{ with: "74px", height: "32px", color: "#999999", borderRadius: "4px" }}
                        onClick={() => navigate(-1)}>
                        返回
                    </Button>
                    <div className="pay-title">支付方式：</div>
                    <div className="pay-way">
                        <div className={payChooseWx == 'wxpay' ? "pay-btn-box choose" : "pay-btn-box"} onClick={() => { setPayChooseWx('wxpay') }} >
                            <img className="pay-icon" src={wxIcon} alt="" />
                            <span>微信支付</span>
                            {
                                payChooseWx == 'wxpay' && <img className="selectIcon" src={selectIcon} alt="" />
                            }

                        </div>
                        {/* <div className={payChooseWx == 'alipay' ? "pay-btn-box choose" : "pay-btn-box"} onClick={() => { setPayChooseWx('alipay') }}>
                            <img className="pay-icon" src={aliIcon} alt="" />
                            <span>支付宝支付</span>
                            {
                                payChooseWx == 'alipay' && <img className="selectIcon" src={selectIcon} alt="" />
                            }
                        </div> */}
                        <div className={payChooseWx == 'paypal' ? "pay-btn-box choose" : "pay-btn-box"} onClick={() => { setPayChooseWx('paypal') }}>
                            <img className="pay-icon" src={xykIcon} alt="" />
                            <span>信用卡支付</span>
                            {
                                payChooseWx == 'paypal' && <img className="selectIcon" src={selectIcon} alt="" />
                            }
                        </div>
                    </div>
                    <Button className="pay-way-btn" onClick={targetPayChooseWx} loading={loading}>立即支付</Button>
                </div>
            </div>
            <Modal
                title={payChooseWx == 'wxpay' ? "微信支付" : '支付宝支付'}
                open={visible}
                onCancel={() => {
                    clearInterval(payTimeRef.current); // 先清除定时器
                    payTimeRef.current = null; // 再将引用置为 null
                    setVisible(false);
                    if (searchParams.get('type') == '0') {
                        navigate('/orderDetail?id=' + searchParams.get('id'),)
                    } else {
                        navigate('/transferOrderDetail?id=' + searchParams.get('id'),)
                    }
                }}
                footer={null}
                centered
                width={460}
                style={{ borderRadius: "4px" }}
            >
                <div className="text-center">
                    {payChooseWx == 'wxpay' && <img
                        width="220px" style={{ marginTop: "10px" }}
                        src={baseUrl + 'tool/qrcode?size=220&content=' + paySchema}
                    />}
                    {payChooseWx == 'alipay' && <iframe
                        width="220px" height="220px"
                        style={{ marginTop: "10px", border: "none", scrolling: "no" }}
                        src={paySchema}
                    // src={baseUrl + 'tool/qrcode?size=220&content=' + paySchema}
                    />}
                </div>
            </Modal>


        </>
    );

}

